module.exports = __webpack_public_path__ + "static/img/v2.96afb3f2.jpg";